<template>
    <v-container fluid>
        <el-breadcrumb separator-class="el-icon-arrow-right" class="mb-3">
        <el-breadcrumb-item :to="{ path: '/' }">แดชบอร์ด</el-breadcrumb-item>
        <el-breadcrumb-item>สมาชิกทั้งหมด</el-breadcrumb-item>
        </el-breadcrumb>

         <el-card class="mt-3">
             <v-data-table
                :headers="headers"
                :items="results"
                :loading="isLoading"
                :page.sync="page"
                :items-per-page="itemsPerPage"
                :mobile-breakpoint="`10`"
                @page-count="pageCount = $event"
                hide-default-footer
                class="elevation-0"
            >
             </v-data-table>
         </el-card>

     </v-container>
</template>
<script>
import Service from "@/services";
export default {
  components: {
  },
  props: [],
  data() {
    return {
        isLoading : true, 
        headers : [
             {
                text: "#",
                align: "left",
                sortable: false,
                value: "",
            },
            { text: "", value: "action", sortable: false },
            { text: "สถานะ", value: "status", sortable: false },
            { text: "ชื่อ-นามสกุล", value: "fullname", sortable: false },
            { text: "เบอร์มือถือ", value: "mobile", sortable: false },
            { text: "อีเมล", value: "email", sortable: false },
            { text: "วันที่สมัครสมาชิก", value: "created_at", sortable: false },
        ],
        results : [],
        page: 1,
        itemsPerPage: 25,
        pageCount: 0,
        refresh: null,
    }
  },
  created(){
      this.isLoading = false
  }
}
</script>